import { createAction } from '@reduxjs/toolkit'

export const requestOpenapiHydrationCacheHas = createAction<{
  id: string
  key: string
}>('requestOpenapiHydrationCacheHas')

export const requestOpenapiHydrationCacheAdd = createAction<{
  id: string
  key: string
}>('requestOpenapiHydrationCacheAdd')

export const requestOpenapiHydrationCacheRemove = createAction<{
  id: string
  key: string
}>('requestOpenapiHydrationCacheRemove')

export const requestOpenapiHydrationCacheClear = createAction<{
  id: string
}>('requestOpenapiHydrationCacheClear')

export const sendOpenapiHydrationCacheResponse = createAction<{
  id: string
  value: boolean | null
  success: boolean
  error?: string
}>('sendOpenapiHydrationCacheResponse')
